// extracted by mini-css-extract-plugin
export default {"active":"ButtonAddOrder_active__-NSI+","default":"ButtonAddOrder_default__9YrMR"};